import { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import api from "api/axios";

const fmt = (n) => (Number(n) || 0).toLocaleString("fr-FR", { minimumFractionDigits: 0, maximumFractionDigits: 2 });

function OumrahRecap() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/oumrah/inscriptions/recap")
      .then((r) => setData(r.data))
      .catch(() => setData({ directeurs: [], est_admin: false }))
      .finally(() => setLoading(false));
  }, []);

  const estAdmin = data && data.est_admin;
  const directeurs = (data && data.directeurs) || [];
  const gT = directeurs.reduce((a, d) => ({ du: a.du + d.total_du, enc: a.enc + d.total_encaisse, reste: a.reste + d.total_reste, part: a.part + d.total_participants }), { du: 0, enc: 0, reste: 0, part: 0 });

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card sx={{ p: 3 }}>
              <MDTypography variant="h5" mb={0.5}>{estAdmin ? "Récapitulatif des directeurs" : "Mon récapitulatif"}</MDTypography>
              <MDTypography variant="button" color="text">Inscriptions, montants dûs, encaissés et restant à encaisser (hors sessions clôturées).</MDTypography>
            </Card>
          </Grid>

          {loading && (<Grid item xs={12}><Card sx={{ p: 3 }}><MDTypography variant="button" color="text">Chargement…</MDTypography></Card></Grid>)}
          {!loading && directeurs.length === 0 && (<Grid item xs={12}><Card sx={{ p: 3 }}><MDTypography variant="button" color="text">Aucune inscription à afficher.</MDTypography></Card></Grid>)}

          {!loading && estAdmin && directeurs.length > 0 && (
            <>
              <Grid item xs={12} md={3}><Card sx={{ p: 2.5, borderTop: "4px solid #1A73E8" }}><MDTypography variant="button" color="text">Participants</MDTypography><MDTypography variant="h4">{gT.part}</MDTypography></Card></Grid>
              <Grid item xs={12} md={3}><Card sx={{ p: 2.5, borderTop: "4px solid #43a047" }}><MDTypography variant="button" color="text">Total dû</MDTypography><MDTypography variant="h4">{fmt(gT.du)} €</MDTypography></Card></Grid>
              <Grid item xs={12} md={3}><Card sx={{ p: 2.5, borderTop: "4px solid #00897b" }}><MDTypography variant="button" color="text">Encaissé</MDTypography><MDTypography variant="h4">{fmt(gT.enc)} €</MDTypography></Card></Grid>
              <Grid item xs={12} md={3}><Card sx={{ p: 2.5, borderTop: "4px solid #e53935" }}><MDTypography variant="button" color="text">Reste à encaisser</MDTypography><MDTypography variant="h4" sx={{ color: gT.reste > 0 ? "#e53935" : "#43a047" }}>{fmt(gT.reste)} €</MDTypography></Card></Grid>
            </>
          )}

          {!loading && directeurs.map((d) => (
            <Grid item xs={12} key={d.directeur_id}>
              <Card sx={{ p: 3 }}>
                <MDBox display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" mb={2}>
                  <MDBox display="flex" alignItems="center" gap={1}>
                    <Icon sx={{ color: "#1A73E8" }}>person</Icon>
                    <MDBox>
                      <MDTypography variant="h6">{estAdmin ? d.nom : "Mes inscriptions"}</MDTypography>
                      {estAdmin && <MDTypography variant="caption" color="text">{d.ville}</MDTypography>}
                    </MDBox>
                  </MDBox>
                  <MDBox textAlign="right">
                    <MDTypography variant="caption" color="text" display="block">{d.total_participants} participant(s)</MDTypography>
                    <MDTypography variant="button" fontWeight="bold" sx={{ color: d.total_reste > 0 ? "#e53935" : "#43a047" }}>Reste : {fmt(d.total_reste)} €</MDTypography>
                  </MDBox>
                </MDBox>
                <MDBox display="flex" py={1} sx={{ borderBottom: "2px solid #e0e0e0" }}>
                  <MDTypography variant="caption" fontWeight="bold" color="text" sx={{ flex: 2 }}>Session</MDTypography>
                  <MDTypography variant="caption" fontWeight="bold" color="text" sx={{ flex: 1, textAlign: "center" }}>Insc.</MDTypography>
                  <MDTypography variant="caption" fontWeight="bold" color="text" sx={{ flex: 1, textAlign: "center" }}>Pers.</MDTypography>
                  <MDTypography variant="caption" fontWeight="bold" color="text" sx={{ flex: 1, textAlign: "right" }}>Dû</MDTypography>
                  <MDTypography variant="caption" fontWeight="bold" color="text" sx={{ flex: 1, textAlign: "right" }}>Encaissé</MDTypography>
                  <MDTypography variant="caption" fontWeight="bold" color="text" sx={{ flex: 1, textAlign: "right" }}>Reste</MDTypography>
                </MDBox>
                {d.sessions.map((s) => (
                  <MDBox key={s.session_id} display="flex" py={1} sx={{ borderBottom: "1px solid #f5f5f5" }}>
                    <MDTypography variant="button" sx={{ flex: 2 }}>{s.session_libelle}</MDTypography>
                    <MDTypography variant="button" sx={{ flex: 1, textAlign: "center" }}>{s.nb_inscriptions}</MDTypography>
                    <MDTypography variant="button" sx={{ flex: 1, textAlign: "center" }}>{s.nb_participants}</MDTypography>
                    <MDTypography variant="button" sx={{ flex: 1, textAlign: "right" }}>{fmt(s.du)} €</MDTypography>
                    <MDTypography variant="button" sx={{ flex: 1, textAlign: "right", color: "#43a047" }}>{fmt(s.encaisse)} €</MDTypography>
                    <MDTypography variant="button" sx={{ flex: 1, textAlign: "right", color: s.reste > 0 ? "#e53935" : "#43a047" }}>{fmt(s.reste)} €</MDTypography>
                  </MDBox>
                ))}
                <MDBox display="flex" py={1} mt={0.5} sx={{ borderTop: "2px solid #e0e0e0" }}>
                  <MDTypography variant="button" fontWeight="bold" sx={{ flex: 4 }}>Total</MDTypography>
                  <MDTypography variant="button" fontWeight="bold" sx={{ flex: 1, textAlign: "right" }}>{fmt(d.total_du)} €</MDTypography>
                  <MDTypography variant="button" fontWeight="bold" sx={{ flex: 1, textAlign: "right", color: "#43a047" }}>{fmt(d.total_encaisse)} €</MDTypography>
                  <MDTypography variant="button" fontWeight="bold" sx={{ flex: 1, textAlign: "right", color: d.total_reste > 0 ? "#e53935" : "#43a047" }}>{fmt(d.total_reste)} €</MDTypography>
                </MDBox>
              </Card>
            </Grid>
          ))}
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default OumrahRecap;
